import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useFunctions, useRefs } from '../hooks';
import { FullscreenWrapper } from '../wrappers';

import { useLocation } from 'react-router-dom';
import { getLocationParams } from '../util';

// Custom imports:
import { Group, Button, Image, Text } from '../components';
import { useEffect } from 'react';
import oip from '../assets/oip.jpg';
import { useTranslation } from 'react-i18next';

export const Auth_destinationView = () => {
  const { run } = useFunctions();
  const { search, pathname } = useLocation();


  // Custom exports:
	const { t } = useTranslation();

  // Custom functions:
	const auth_destinationParams = () => {
		run( getLocationParams( search, pathname ) )
	}
	useEffect( auth_destinationParams, [])
	const auth_destinationOnLoaded = async (options) => {
		run([{"id":"set1689368550971","function":"set","what":"@property.nombre","value":"@firebase.firestore.usuarios.(@firebase.user.id).nombre"},{"id":"set1689355521270","function":"set","what":"@property.ini","value":"@app.timestamp"},{"id":"set1689355521270","function":"set","what":"@property.keyhistorial","value":"his(@property.ini)"},{"id":"add1689355521270","function":"add","what":{"accion":"(@property.nombre) ha creado una cuenta nueva","timestamp":"@app.timestamp"},"to":"@firebase.firestore.historial","key":"@property.keyhistorial"}], options)
	}
	useEffect( auth_destinationOnLoaded, [])
	const text1678525469256OnClick = async (options) => {
		run([{"id":"set1686670965806","function":"set","what":"@property.contenido","value":"Hola y bienvenido a nuestra p\u00e1gina web de intermediarios de compra y venta de farmacias!\n\nEn nombre de todo nuestro equipo, es un placer darte la bienvenida a este espacio dise\u00f1ado especialmente para conectar a aquellos que desean comprar o vender una farmacia. Aqu\u00ed encontrar\u00e1s una plataforma confiable y segura que te brindar\u00e1 todas las herramientas necesarias para llevar a cabo exitosas transacciones en el sector farmac\u00e9utico.\n\nSabemos que la compra o venta de una farmacia es una decisi\u00f3n importante y que requiere de un proceso cuidadoso y bien estructurado. Es por eso que estamos aqu\u00ed para acompa\u00f1arte en cada paso del camino, ofreci\u00e9ndote nuestra experiencia, conocimiento y dedicaci\u00f3n para asegurarnos de que tu experiencia sea lo m\u00e1s transparente y satisfactoria posible.\n\nNuestro equipo de intermediarios altamente capacitados est\u00e1 comprometido en brindarte un servicio personalizado y profesional. Trabajaremos estrechamente contigo para entender tus necesidades, objetivos y expectativas, y as\u00ed poder ayudarte a encontrar la mejor opci\u00f3n de compra o venta que se ajuste a tus requerimientos.\n\nEn nuestra p\u00e1gina web, encontrar\u00e1s una amplia variedad de listados actualizados de farmacias disponibles para la compra o venta, acompa\u00f1ados de informaci\u00f3n detallada sobre cada una de ellas. Adem\u00e1s, te proporcionaremos valiosa informaci\u00f3n sobre el mercado farmac\u00e9utico, tendencias, regulaciones y consejos \u00fatiles para que tomes decisiones informadas y acertadas.\n\nTe invitamos a explorar nuestro sitio web y a descubrir todo lo que tenemos para ofrecerte. Si en alg\u00fan momento tienes preguntas o necesitas asistencia, no dudes en contactarnos. Estamos aqu\u00ed para ayudarte y responder a todas tus inquietudes.\n\nGracias por elegirnos como tu plataforma de intermediaci\u00f3n en el sector farmac\u00e9utico. Esperamos que encuentres aqu\u00ed la soluci\u00f3n que est\u00e1s buscando y que tu experiencia sea gratificante.\n\n\u00a1Bienvenido a nuestra comunidad de intermediarios de compra y venta de farmacias!\n\nAtentamente,\n\nEl equipo de quieromifarma.com"},{"id":"set1686670965806","function":"set","what":"@property.asunto","value":"Bienvenido a quieromifarma.com"},{"id":"add1686670965806","function":"add","what":{"contenido":"@property.contenido","email":"@firebase.firestore.usuarios.(@cookie.userID).email","asunto":"@property.asunto"},"to":"@firebase.firestore.enviarmail"},{"id":"goto1678532194462","function":"goto","view":"formularioventa"}], options)
	}
	const authLogoutButtonOnClick = async (options) => {
		run([{"function":"goto","view":"auth_logout"}], options)
	}

  return (
    <>
      <Helmet>
				<title>{t('auth_destination.title')}</title>
      </Helmet>
      <FullscreenWrapper>
          
			<Group
				id="logoutBody"
				direction="vertical"
				className="w-100 h-fill valign-center position-absolute" >
				<Button
					id="authLogoutButton"
					visible={false}
					onClick={authLogoutButtonOnClick}
					variant="primary-light"
					className="w-auto h-auto align-center valign-center position-absolute" >
					{t('auth_destination.authLogoutButton')}
				</Button>
				<Group
					id="gruponombre1678525279943"
					direction="vertical"
					className="w-100 h-auto position-relative" >
					<Group
						id="grupopregunta1678525279943"
						direction="horizontal"
						className="max-w-900px w-90 h-auto align-center position-relative p-3px" >
						<Image
							id="image1678525279943"
							src={oip}
							className="w-15 h-auto border-radius-40px align-center valign-center position-relative m-20px" />
						<Group
							id="group1678525279943"
							direction="vertical"
							className="w-auto h-auto border-radius-30px valign-center position-relative bg-primary-light-to-primary-dark" >
							<Text
								id="text1678525279943"
								className="w-auto h-auto border-radius-20px align-center position-relative p-20px text-text-on-accent f-15px text-center" >
								{t('auth_destination.text1678525279943')}
							</Text>
							<Text
								id="text1678525394157"
								className="w-auto h-auto border-radius-20px align-center position-relative p-20px text-text-on-accent f-15px text-center" >
								{t('auth_destination.text1678525394157')}
							</Text>
						</Group>
					</Group>
					<Text
						id="text1678525469256"
						onClick={text1678525469256OnClick}
						className="max-w-350px w-100 h-auto border-radius-20px align-center valign-end position-relative bg-accent p-20px m-80px text-text-on-accent text-center" >
						{t('auth_destination.text1678525469256')}
					</Text>
				</Group>
			</Group>
      </FullscreenWrapper>
    </>
  );
};
